import { useEffect } from 'react';

/**
 * Hook to add animation styling to the document
 */
export function useCheckInAnimation() {
  useEffect(() => {
    // Add the animations if they don't exist
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .animate-fade-in {
        animation: fadeIn 0.8s ease-in-out forwards;
      }
      
      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
        40% {transform: translateY(-10px);}
        60% {transform: translateY(-5px);}
      }
      .animate-bounce {
        animation: bounce 1s ease-in-out 3;
      }
      
      .scroll-behavior-smooth {
        scroll-behavior: smooth;
      }
    `;
    document.head.appendChild(style);
    
    // Add smooth scrolling to document
    document.documentElement.classList.add('scroll-behavior-smooth');
    
    // Clean up
    return () => {
      document.documentElement.classList.remove('scroll-behavior-smooth');
    };
  }, []);
}

/**
 * Helper function to scroll to an element with an optional animation
 */
export function scrollToElementWithAnimation(element: HTMLElement | null, animate: boolean = false) {
  if (!element) return;
  
  // Scroll to element
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  
  // Animate if requested
  if (animate) {
    // Remove existing animation class first
    element.classList.remove('animate-bounce');
    // Trigger a reflow to restart the animation
    void element.offsetWidth;
    // Add the animation class
    element.classList.add('animate-bounce');
  }
}
